import { slicedToArray as _slicedToArray } from '../../../../../../_virtual/_rollupPluginBabelHelpers.js';
import { checkIsTouchDevice } from './check_is_touch_device.js';

var handleHistory = function handleHistory($gallery, galleryName, selectedImageNumber, remove, showImage) {
  var handlePopstateWrapper = function handlePopstateWrapper(ev) {
    handlePopstate(remove, showImage, ev);
  };

  var replaceHistoryStateWithGalleryHash = function replaceHistoryStateWithGalleryHash(imageNumber) {
    window.history.replaceState(null, document.title, "#galleryName=".concat(galleryName, ",imageNumber=").concat(imageNumber));
  };

  if (checkIsTouchDevice()) {
    var initLocation = window.location.href;
    var hash = window.location.hash;
    var isGalleryNameInHash = hash.includes('galleryName');

    if (isGalleryNameInHash) {
      var isGalleryCopied = hash.includes('-copied');

      if (isGalleryCopied) {
        window.history.replaceState(null, '', window.location.origin + window.location.pathname);
        setTimeout(function () {
          window.history.pushState(null, '', initLocation);
        }, 0);
      }
    } else {
      window.history.pushState(null, document.title, "#galleryName=".concat(galleryName, ",imageNumber=").concat(selectedImageNumber));
    }
  } else {
    replaceHistoryStateWithGalleryHash(selectedImageNumber);
    window.addEventListener('beforeunload', remove);
  }

  $gallery.addEventListener('nextImage', function (ev) {
    replaceHistoryStateWithGalleryHash(ev.detail.selectedImageNumber);
  });
  $gallery.addEventListener('previousImage', function (ev) {
    replaceHistoryStateWithGalleryHash(ev.detail.selectedImageNumber);
  });
  window.addEventListener('popstate', handlePopstateWrapper);
  $gallery.addEventListener('removeGallery', function () {
    window.removeEventListener('popstate', handlePopstateWrapper);
    window.removeEventListener('beforeunload', remove);
  });
};

var handlePopstate = function handlePopstate(remove, showImage, ev) {
  var hash = window.location.hash;
  var isGalleryNameInHash = hash.includes('galleryName');

  if (!isGalleryNameInHash) {
    remove(ev);
  } else {
    if (!checkIsTouchDevice()) {
      var _hash$split3 = hash.split(',imageNumber='),
          _hash$split4 = _slicedToArray(_hash$split3, 2),
          galleryNameString = _hash$split4[0],
          imageNumberString = _hash$split4[1];

      var hashNameLength = '#galleryName='.length;
      var galleryNameIndex = galleryNameString.indexOf('#galleryName=');
      var galleryName = galleryNameString.slice(hashNameLength + galleryNameIndex);
      var isGalleryCopied = imageNumberString === null || imageNumberString === void 0 ? void 0 : imageNumberString.includes('-copied');
      var imageNumber = isGalleryCopied ? +imageNumberString.replace('-copied', '') : +imageNumberString;
      var $images = document.querySelectorAll("[data-gallery-name=".concat(galleryName, "]"));
      var isImageNumberValid = imageNumber > 0 && imageNumber <= $images.length;

      if (isImageNumberValid) {
        showImage(imageNumber - 1);
      } else {
        window.history.replaceState(null, document.title, "#galleryName=".concat(galleryName, ",imageNumber=1"));
        showImage(0);
      }
    }
  }
};

export { handleHistory };
//# sourceMappingURL=handle_history.js.map
